//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { formatTime } from '../../../components/helpers.js'
import { businessProcessEventsHistory } from './businessProcessEventsHistory.js'

import Table from '../../../components/Table/Table.vue'

export default {
  components: {
    Table
  },
  mixins: [businessProcessEventsHistory],
  props: {
    record: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      pagination: {
        rowsPerPage: 0, // all
        page: 1
      },
      columns: [
        {
          name: 'name',
          label: 'Событие',
          align: 'left',
          field: this.getExtendedEventName,
          sortable: true
        },
        {
          name: 'stateAlias',
          label: 'Статус задания',
          align: 'left',
          field: 'stateAlias',
          format: row => row,
          sortable: true
        },
        {
          name: 'time',
          label: 'Дата/время события',
          align: 'left',
          field: 'time',
          format: formatTime,
          sortable: true
        },
        {
          name: 'fio',
          label: 'Пользователь',
          align: 'left',
          field: 'fio',
          sortable: true
        }
      ]
    }
  }
}

